import React from 'react'
import { Table } from 'components'
import { ArticleTypes } from 'types'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Gtm } from 'helpers'

interface Props extends RouteComponentProps<any> {
    weekIndex: number,
    items: ArticleTypes.Article[]
}

class VarietiesTable extends React.Component<Props> {

    public handleClick = (item: ArticleTypes.Article) => {
        // GTM
        Gtm.pushFlowEvent('productClick', {
            click: {
                actionField: {
                    list: 'New Surplus order choose product'
                },
                products: [{
                    name: `${item.productGroupName} - ${item.name}`,
                    id: item.articleId,
                    brand: 'New Surplus Order',
                    position: 1
                }]
            }
        })
        // End GTM

        this.props.history.push('/add/' + item.id + '?week=' + item.availability[this.props.weekIndex].week)
    }

    public render() {

        const generateColumns = [
            {
                header: 'Product name',
                accessor: 'name',
                cell: (cellInfo: any) => (
                    <div>
                        <small>{cellInfo.productGroupName}</small>
                        {cellInfo.name}
                    </div>
                )
            },
            {
                header: 'Product form',
                accessor: 'formName',
                cell: (cellInfo: any) => <small>{cellInfo.formName}</small>
            },
            {
                header: 'Amount',
                accessor: (d: ArticleTypes.Article) =>
                    this.props.weekIndex > -1 ? d.availability[this.props.weekIndex].quantity : 0
            }
        ]

        return (
            <Table
                variant="primary"
                data={this.props.items}
                columns={generateColumns}
                onRowClick={this.handleClick}
            />
        )
    }
}

export default withRouter(VarietiesTable)



// WEBPACK FOOTER //
// ./src/components/VarietiesTable/index.tsx